<template>
  <div class="container">
    @include('user.components.categories-title')
    <br />
    <h3 class="mt-5">{{ __("page.cart.title") }}</h3>
    <div class="row">
      <div class="col-md-8 px-md-3 px-0 col-12">
        <div class="box-form">
          <div class="row p-lg-3 py-3 px-">
            <div
              class="
                col-lg-1 col-12
                px-lg-3 px-0
                mb-4 mb-lg-3
                align-self-center
              "
            >
              <label class="container-checkbox d-flex justify-content-between">
                <input
                  class="checkbox-category align-self-center"
                  type="checkbox"
                  checked="checked"
                  id="select-all"
                />
                <span class="checkmark-category align-self-center"></span>
                <strong class="hide-high-lg blue-color align-self-center"
                  >Kamera DSLR</strong
                >
                <a href=""
                  ><img
                    class="img-fluid hide-high-lg"
                    width="30"
                    src=""
                /></a>
              </label>
            </div>
            <div class="col-lg-3 col-4 px-lg-3 px-0 align-self-center">
              {{ __("page.cart.select_all") }}
            </div>
            <div class="col-lg-7 col-8 pr-lg-3 pr-0"></div>
            <div class="col-1 px-lg-3 px-1 align-self-center hide-low-lg">
              <a href="">{{ __("page.cart.remove") }}</a>
            </div>
          </div>
        </div>

        @foreach ($cart_items as $cart_item)
        @include('user.components.cart-product') @endforeach
      </div>
      <div class="col-md-4 col-12 px-lg-3 px-0">
        <div class="box-form p-4">
          <h3>{{ __("page.cart.summary") }}</h3>
          <br />
          <div>{{ __("page.cart.price_total_goods") }} (5)</div>
          <h5 id="price_subtotal"></h5>
          <br />
          <hr class="hr-category" />
          <br />
          <h4>{{ __("page.cart.price_total") }}</h4>
          <h3 id="price_total"></h3>
          <br />
          <a href="">
            <button
              type="button"
              class="btn btn-primary bg-blue border-radius-16 py-3 w-100"
            >
              <h5>Checkout</h5>
            </button>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  
}
</script>